import { PropertyTypeID } from '@klokhuis/core/ApiClient/Klokhuis';

import { AnalyticsPageName } from '../types';

export function getListingAnalyticsPageName(
  listingTypeIds: Array<PropertyTypeID> | null,
): string {
  if (!listingTypeIds || listingTypeIds.length !== 1) {
    return AnalyticsPageName.SearchLivingPlace;
  }

  const pageNameMap: Record<PropertyTypeID, string> = {
    [PropertyTypeID.ResidentialLand]: AnalyticsPageName.SearchResidentialLand,
    [PropertyTypeID.HouseOrVilla]: AnalyticsPageName.SearchHouseOrVilla,
    [PropertyTypeID.FarmLand]: AnalyticsPageName.SearchFarmLand,
    [PropertyTypeID.CommercialLand]: AnalyticsPageName.SearchCommercialLand,
  };

  return pageNameMap[listingTypeIds[0]!] ?? AnalyticsPageName.SearchLivingPlace;
}
